<template>
  <div>
    <el-card style="margin: auto">
      <div slot="header" class="clearfix">
        <span style="float:left; font-weight: 800">{{ this.$route.params.name }} 命令行</span>
        <el-select
          size="mini"
          v-model="cmd"
          style="float:right"
          @change="change_shell"
          placeholder="请选择shell"
        >
          <el-option v-for="i in cmds" :key="i" :value="i" :label="i"></el-option>
        </el-select>
      </div>
      <div ref="terminal"></div>
    </el-card>
  </div>
</template>

<script>
import { Terminal } from "xterm";
import { FitAddon } from "xterm-addon-fit";
// import { AttachAddon } from "xterm-addon-attach";
import { WebLinksAddon } from "xterm-addon-web-links";
import "xterm/css/xterm.css";

export default {
  data() {
    return {
      xterm: null,
      socket: "",
      sessionId: "",
      cmds: ["sh", "bash"],
      cmd: "sh",
    };
  },
  methods: {
    change_shell(shell) {
      this.cmd = shell;
      if (this.xterm) {
        // 销毁终端
        this.xterm.dispose();
      }
      // 根据给定的shell重开一个
      this.open_terminal(shell);
    },
    open_terminal(shell) {
      const _this = this;
      _this.xterm = new Terminal({
        cursorBlink: true,
        rows: 60,
      });
      //加载自适应组件
      _this.fitAddon = new FitAddon();
      _this.xterm.loadAddon(_this.fitAddon);

      //加载weblink组件
      _this.xterm.loadAddon(new WebLinksAddon());

      //在绑定的组件上初始化窗口
      _this.xterm.open(_this.$refs.terminal);

      //窗口初始化后,按照浏览器窗口自适应大小
      _this.fitAddon.fit();

      //聚焦
      _this.xterm.focus();

      // 根据path生成websocket的url
      const m = this.config.path.split("://");
      const wsurl = this.config.terminal_prefix + m[1];

      //创建ws实例
      //这里还把窗口的column和row传入后端,使其能自动针对前端窗口边框改为输出
      _this.socket = new WebSocket(
        wsurl +
          "/pods/" +
          _this.$route.params.name +
          "?cluster=" +
          _this.$route.params.cluster +
          "&namespace=" +
          _this.$route.params.namespace +
          "&container=" +
          _this.$route.query.container +
          "&terminal=true&cmd=" +
          shell +
          "&token=" +
          _this.config.getCookie()
      );

      _this.socket.onmessage = function (event) {
        // 服务端ssh输出, 写到web shell展示
        _this.xterm.write(event.data);
      };

      _this.socket.onerror = function (event) {
        console.log(event);
        _this.$message({
          showClose: true,
          message: "403 forbidden: can not get terminal",
          type: "error",
        });
      };

      // 当浏览器窗口变化时, 重新适配终端
      window.addEventListener("resize", function () {
        _this.xterm.fit();

        // 把web终端的尺寸term.rows和term.cols发给服务端, 通知sshd调整输出宽度
        var msg = {
          type: "resize",
          rows: _this.xterm.rows,
          cols: _this.xterm.cols,
        };
        _this.socket.send(JSON.stringify(msg));

        // console.log(term.rows + "," + term.cols)
      });
      // 当向web终端敲入字符时候的回调
      _this.xterm.onData((input) => {
        // console.log(input);
        // 写给服务端, 由服务端发给container
        var msg = { type: "input", input: input };
        _this.socket.send(JSON.stringify(msg));
      });
    },
  },
  mounted() {
    this.open_terminal(this.cmd);
  },
  befordDestroy() {
    if (this.xterm) {
      this.xterm.dispose();
    }
  },
};
</script>
